import { MRT_ColumnDef } from 'mantine-react-table'
import { memo } from 'react'
import CustomTooltip from 'src/components/CustomComponents/CustomTooltip'
import ChangelogPageList from 'src/containers/Changelog'
import { size } from 'src/variable/constant'

function ChangelogPage() {
	const columns: MRT_ColumnDef[] = [
		{
			accessorKey: 'no',
			header: 'No',
			size: size.zero,
		},
		{
			accessorKey: 'title',
			header: 'Title',
			size: size.zero,
			maxSize: size.text,
			Cell: ({ cell }) => (
				<CustomTooltip label={cell.getValue<string>()} maxWidth={size.text} />
			),
		},
		{
			accessorKey: 'description',
			header: 'Description',
			size: size.zero,
			maxSize: size.medium,
			Cell: ({ cell }) => (
				<CustomTooltip label={cell.getValue<string>() || ''} maxWidth={size.medium} />
			),
		},
		// {
		// 	accessorKey: 'version',
		// 	header: 'Version',
		// 	size: size.zero,
		// 	maxSize: size.text,
		// 	Cell: ({ cell }) => <>{cell.getValue<string>() || ''}</>,
		// },
		{
			accessorKey: 'published_at',
			header: 'Published at',
			size: size.zero,
			maxSize: size.text,
		},
		{
			accessorKey: 'created_at',
			header: 'Created at',
			size: size.zero,
			maxSize: size.text,
		},
		{
			accessorKey: 'updated_at',
			header: 'Updated at',
			size: size.zero,
			maxSize: size.text,
		},
	]

	const fields = [
		{
			value: 'title',
			label: 'Title',
		},
		{
			value: 'description',
			label: 'Description',
		},
		// {
		// 	value: 'version',
		// 	label: 'Version',
		// },
	]

	return <ChangelogPageList columns={columns} fields={fields} />
}

export default memo(ChangelogPage)
